module.exports = __webpack_public_path__ + "img/img8.fa0424ad.png";